import { styled } from '@linaria/react';
import { breakpoints, space } from '../../theme/tokens';

export const CardGrid = styled.div<{
  $columns?: number;
  $mobileColumns?: number;
  $tabletColumns?: number;
  $flushBottom?: boolean;
  $columnGapMobile?: string;
  $rowGapMobile?: string;
  $columnGapTablet?: string;
  $rowGapTablet?: string;
}>`
  display: grid;
  grid-template-columns: repeat(${({ $mobileColumns }) => $mobileColumns ?? 1}, 1fr);
  gap: ${({ $rowGapMobile, $columnGapMobile }) =>
    `${$rowGapMobile ?? space['space-600']} ${$columnGapMobile ?? space['space-600']}`};
  margin-bottom: ${({ $flushBottom }) => ($flushBottom ? '0' : space['space-2400'])};

  @media (min-width: ${breakpoints.tablet}) {
    grid-template-columns: repeat(
      ${({ $tabletColumns, $columns }) => $tabletColumns ?? $columns ?? 2},
      1fr
    );
    row-gap: ${({ $rowGapTablet }) => $rowGapTablet ?? space['space-1000']};
    column-gap: ${({ $columnGapTablet }) => $columnGapTablet ?? space['space-600']};
  }

  @media (min-width: ${breakpoints.desktop}) {
    grid-template-columns: repeat(${({ $columns }) => $columns ?? 2}, 1fr);
  }
`;
